module.exports = __webpack_public_path__ + "static/media/language.d1d84a18.webp";